import React from "react"
import clsx from "clsx"
import { twMerge } from "tailwind-merge"

interface Props {
	label: string
	icon: React.ReactNode
	variant: "success" | "danger" | "warning"
	className?: string
}

const EventBox: React.FC<Props> = ({ label, icon, variant = "success", className }) => {
	const containerClass = twMerge(
		clsx(
			"flex items-center justify-between space-x-4 rounded-2 border px-4 py-3",
			{
				"bg-[#F9FAFB] border-[#84CAFF]": variant === "success",
				"bg-[#FEF3F2] border-[#FDA29B]": variant === "danger",
				"bg-[#FFFAEB] border-[#FEC84B]": variant === "warning",
			},
			className,
		),
	)

	const textClass = twMerge(
		clsx("font-medium", {
			"text-[#1849A9]": variant === "success",
			"text-[#912018]": variant === "danger",
			"text-[#93370D]": variant === "warning",
		}),
	)

	return (
		<div className={containerClass}>
			<span className={textClass}>{label}</span>
			{icon && <span className="h-[20px] w-[20px]">{icon}</span>}
		</div>
	)
}

export default EventBox
